import { render, staticRenderFns } from "./atfx.vue?vue&type=template&id=041198c6&scoped=true"
import script from "./atfx.vue?vue&type=script&lang=js"
export * from "./atfx.vue?vue&type=script&lang=js"
import style0 from "./atfx.vue?vue&type=style&index=0&id=041198c6&prod&lang=css"
import style1 from "./atfx.vue?vue&type=style&index=1&id=041198c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041198c6",
  null
  
)

export default component.exports